import { GitBranch, Clock3 } from 'lucide-react';
import { VERSION_HISTORY } from '../config/versionHistory';

export function VersionHistory() {
  return (
    <div className="space-y-4">
      <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
        <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-blue-900 px-6 py-6 text-white">
          <div className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-blue-100 ring-1 ring-white/10">
            Sürüm Yönetimi
          </div>
          <h1 className="mt-4 text-3xl font-semibold tracking-tight">Versiyon Geçmişi</h1>
          <p className="mt-2 max-w-3xl text-sm text-slate-200">
            Uygulamanın her sürümünde yapılan değişiklikleri, iyileştirmeleri ve operasyonel güncellemeleri tek listede takip edin.
          </p>
        </div>
      </div>

      <div className="space-y-4">
        {VERSION_HISTORY.map((entry, index) => (
          <div key={entry.version} className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
            <div className="px-6 py-5 border-b border-slate-200 bg-slate-50 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <div>
                <div className="flex items-center gap-2 text-slate-500 text-sm">
                  <GitBranch className="w-4 h-4" />
                  <span>Sürüm {entry.version}</span>
                </div>
                <h2 className="mt-2 text-xl font-semibold text-slate-900">{entry.title}</h2>
                <p className="mt-1 text-sm text-slate-600">{entry.summary}</p>
              </div>
              <div className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-xs font-medium text-slate-600 ring-1 ring-slate-200">
                <Clock3 className="w-3.5 h-3.5" />
                {new Date(entry.releaseDate).toLocaleDateString('tr-TR')}
              </div>
            </div>

            <div className="px-6 py-5">
              <div className="space-y-3">
                {entry.items.map((item) => (
                  <div key={`${entry.version}-${item}`} className="flex items-start gap-3 text-sm text-slate-700">
                    <div className={`mt-1 h-2.5 w-2.5 rounded-full ${index === 0 ? 'bg-blue-600' : index === 1 ? 'bg-emerald-600' : 'bg-slate-400'}`} />
                    <div>{item}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
